/*
 * @Author: wangshengqiang
 * @Date: 2021-05-08 17:04:17
 * @LastEditTime: 2021-05-08 17:04:17
 * @LastEditors: wangshengqiang
 * @Description:
 */
import { useCallback, useEffect, useState } from 'react';
import { dispatch, getState, subscribe } from '../store';
export const useStore = (path, initialState, storage = false) => {
  if (storage) {
    const v = localStorage.getItem(path);

    if (v) {
      initialState = JSON.parse(v);
    }
  }

  const [state, setState] = useState(getState(path) || initialState);
  useEffect(() => {
    subscribe(setState, path);
  }, [path]);
  const nextDispatch = useCallback(value => {
    dispatch(path, value);

    if (storage) {
      localStorage.setItem(path, JSON.stringify(value));
    }
  }, [path, storage]);
  return [state, nextDispatch];
};
export default useStore;